<template>
  <div
    class="product-cart-wrap small"
    @click="$router.push(`/product/${item.slug}`)"
  >
    <div class="product-img-action-wrap">
      <div class="product-img product-img-zoom">
        <router-link :to="`/product/${item.slug}`">
          <img
            class="default-img lazyload"
            :data-src="item.images[0].file_url"
            height="170"
            data-sizes="auto"
            width="232"
            alt=""
          />
        </router-link>
      </div>
      <div class="product-action-1"></div>
      <div class="product-badges product-badges-position product-badges-mrg">
        <span class="hot">New</span>
      </div>
    </div>
    <div class="product-content-wrap">
      <h2>
        <router-link :to="`/product/${item.slug}`">
          {{ item.name }}
        </router-link>
      </h2>
      <div class="rating-result" title="90%">
        <span></span>
      </div>
      <div class="product-price">
        <span>
          {{
            formatPrice(
              isCartable ? item.vat_selling_price : item.selling_price
            )
          }}
        </span>
        <span v-if="isCartable" class="old-price">{{
          formatPrice(item.vat_actual_price)
        }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { formatPrice } from "@/lib/utils";

const props = defineProps(["item"]);

const isCartable = props.item.type === "product";
</script>

<style scoped>
.product-cart-wrap {
  position: relative;
  background-color: #fff;
  border: 1px solid #cce7d0;
  border-radius: 25px;
  overflow: hidden;
  transition: 0.2s;
  -moz-transition: 0.2s;
  -webkit-transition: 0.2s;
  -o-transition: 0.2s;
}
.product-cart-wrap.small {
  border: 0;
  text-align: center;
  width: 190px;
}
.product-cart-wrap .product-img-action-wrap {
  position: relative;
  background-color: #fff;
  padding: 10px 12px;
  overflow: hidden;
  max-height: 320px;
}
.product-cart-wrap .product-img-action-wrap .product-img {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}
.product-cart-wrap .product-content-wrap h2 a {
  color: #1a1a1a;
  cursor: pointer;
  text-decoration: none;
}
.product-img {
  border: 1px solid #cce7d0;
}
.product-cart-wrap .product-img-action-wrap .product-img a {
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  text-decoration: none;
  cursor: pointer;
}
.product-cart-wrap .product-img-action-wrap .product-img a img {
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.product-cart-wrap .product-badges.product-badges-position {
  position: absolute;
  left: 20px;
  top: 19px;
  z-index: 9;
}
.product-cart-wrap .product-badges.product-badges-mrg {
  margin: 0 0 10px;
}
.product-cart-wrap .product-badges {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.product-cart-wrap .product-badges span {
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  border-radius: 40px;
  color: #fff;
  padding: 5px 10px;
}
.product-cart-wrap .product-badges span:last-child {
  margin-right: 0px;
}
.product-cart-wrap .product-badges span.hot {
  background-color: #f81f1f;
}
.product-cart-wrap.small .product-content-wrap {
  padding: 5px 15px 0 15px;
}
.product-cart-wrap .product-content-wrap h2,
.product-cart-wrap .product-content-wrap h2 a {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  vertical-align: middle;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
  width: 95%;
}
.product-cart-wrap.small h2 {
  border-bottom: 0;
  padding: 0;
  margin-bottom: 0;
  color: #222222;
}
.product-cart-wrap.small .product-price {
  padding-top: 0;
}
.product-cart-wrap .product-content-wrap .product-price {
  padding-top: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  flex-direction: column;
}
.product-cart-wrap .product-content-wrap .product-price span {
  font-size: 18px;
  font-weight: bold;
  color: var(--primary-color);
}
.product-cart-wrap .product-content-wrap .product-price span.old-price {
  font-size: 14px;
  font-weight: 400;
  color: #90908e;
  margin: 0 0 0 7px;
  text-decoration: line-through;
}
.product-content-wrap h2 {
  text-overflow: ellipsis;
  max-height: 20px;
  overflow: hidden;
  white-space: wrap;
  text-align: left;
}
</style>
